module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/87e8b020a5518bc77ca4ff629a09ca37.png";